import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private gaId = environment.googleAnalyticsId;

  constructor(private router: Router) {
    if (this.gaId) {
      this.loadGtag();
      this.trackPageViews();
    }
  }

  private loadGtag(): void {
    // Load external gtag.js script
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${this.gaId}`;
    document.head.appendChild(gtagScript);

    // Load inline initialization script
    const initScript = document.createElement('script');
    initScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${this.gaId}');
    `;
    document.head.appendChild(initScript);
  }

  private trackPageViews(): void {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      (window as any).gtag('config', this.gaId, { page_path: event.urlAfterRedirects });
    });
  }
}
